"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _reactContainerQuery = require("react-container-query");

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _TextInput = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/TextInput");

var _TextInput2 = _interopRequireDefault(_TextInput);

var _Select = require("../../Select/Select");

var _Select2 = _interopRequireDefault(_Select);

var _euCountries = require("@quixeltools/quixel-ui-library/dist/utils/euCountries");

var _euCountries2 = _interopRequireDefault(_euCountries);

var _CountriesList = require("@quixeltools/quixel-ui-library/dist/utils/CountriesList");

var _quixelBusinessCountries = require("@quixeltools/quixel-business-countries");

var _quixelBusinessCountries2 = _interopRequireDefault(_quixelBusinessCountries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var countries = _quixelBusinessCountries2.default.map(function (country) {
  return {
    name: country.name,
    value: country.code
  };
});

var addressFormFields = function addressFormFields(small) {
  return (0, _glamor.css)({
    display: small ? "block" : "flex",
    flexWrap: "wrap",
    justifyContent: "space-between"
  });
};

var field = (0, _glamor.css)({
  flexBasis: "48.85%",
  flexShrink: 0,

  marginTop: "1.5em"
});

var select = (0, _glamor.css)({
  width: "100%"
});

// eslint-disable-next-line no-underscore-dangle
var isEUCountry = _ramda2.default.contains(_ramda2.default.__, _euCountries2.default);

var AddressFormFields = function AddressFormFields(props) {
  /* We're having to wrap this in an extra div to avoid
   * bad layout that happens due to react-container-query
   * appending an extra child to the element
   */

  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "div",
      {
        className: addressFormFields(
        // eslint-disable-next-line
        props.containerQuery && props.containerQuery.small)
      },
      _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
        simpleError: true,
        className: field,
        disabled: props.disabled,
        label: "* Full Name",
        autoFocus: true
      }, props.fields.name)),
      _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
        simpleError: true,
        className: field,
        disabled: props.disabled,
        label: "Company"
      }, props.fields.company)),
      _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
        simpleError: true,
        className: field,
        disabled: props.disabled,
        label: "* Address"
      }, props.fields.address)),
      _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
        simpleError: true,
        className: field,
        disabled: props.disabled,
        label: "Address line 2"
      }, props.fields.address2)),
      _react2.default.createElement(_Select2.default, (0, _extends3.default)({
        thinLabel: true,
        className: (0, _glamor.css)(field, select),
        label: "* Country",
        disabled: props.lockCountryAndVat || props.disabled,
        options: countries
      }, _ramda2.default.omit(["touched", "setFocused"], props.fields.country), {
        error: props.fields.country.error && props.fields.country.touched ? "true" : "",
        onChange: function onChange(event) {
          if (event.target.value === "US" || event.target.value === "CA") {
            props.onChangeCountryHandler();
          }
          props.fields.country.onChange(event);
        }
      })),
      (props.fields.country.value === "US" || props.fields.country.value === "CA") && _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
        className: field,
        disabled: props.disabled,
        label: "* Postal Code",
        errorBelow: true
      }, props.fields.postalCode)),
      (props.fields.country.value === "US" || props.fields.country.value === "CA" || props.fields.country.value === "IN") && _react2.default.createElement(_Select2.default, (0, _extends3.default)({
        thinLabel: true,
        className: (0, _glamor.css)(field, select),
        label: "* State/province/region",
        disabled: props.lockCountryAndVat || props.disabled || !(props.fields.country.value !== "IN" ? props.stateList.length > 0 && props.fields.postalCode.value.length > 0 && props.loaded : true),
        options: props.stateList || []
      }, _ramda2.default.omit(["touched", "setFocused"], props.fields.state), {
        error: props.fields.state.value === "" && props.fields.state.touched ? "true" : "",
        onChange: function onChange(event) {
          var state = props.stateList.find(function (state) {
            return event.target.value === state.name;
          });
          props.fields.mainDivision.onChange(state.code);
          props.fields.state.onChange(event);
        }
      })),
      (props.fields.country.value === "US" || props.fields.country.value === "CA") && _react2.default.createElement(_Select2.default, (0, _extends3.default)({
        simpleError: true,
        thinLabel: true,
        className: (0, _glamor.css)(field, select),
        label: "* City",
        disabled: props.disabled || !(props.citiesList.length > 0 && props.loaded)
      }, props.fields.city, {
        options: props.citiesList || []
      })),
      props.fields.country.value !== "US" && props.fields.country.value !== "CA" && _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
        simpleError: true,
        className: field,
        disabled: props.disabled,
        label: "* City"
      }, props.fields.city)),
      props.fields.country.value !== "US" && props.fields.country.value !== "CA" && _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
        simpleError: true,
        className: field,
        disabled: props.disabled,
        label: "* Postal Code",
        errorBelow: true
      }, props.fields.postalCode)),
      isEUCountry(props.fields.country.value) && !(props.lockCountryAndVat && !props.fields.vatNo.value) && _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
        className: field,
        label: "Registered EU Business",
        placeholder: "EU VAT ID",
        disabled: props.lockCountryAndVat || props.disabled,
        loading: props.validatingVat,
        errorBelow: true,
        onChange: function onChange(event) {
          props.fields.validatingField.onChange("vatNo");
          props.fields.isPromoCodeValid.onChange(props.fields.promoCode.valid);
          props.fields.vatNo.onChange(event);
        }
      }, _ramda2.default.omit(["onChange"], props.fields.vatNo)))
    )
  );
};

exports.default = (0, _reactContainerQuery.applyContainerQuery)(AddressFormFields, {
  small: {
    maxWidth: 499
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PaymentForm/component/AddressFormFields.jsx
// module id = 647
// module chunks = 0